import { Routes } from 'constants/pages';
import * as React from 'react';
import { Link } from 'react-router-dom';

export const Policies: React.FC = () => {
  return (
    <div className="text-gray-900">
      By continuing, you’re agreeing to our{' '}
      <Link target="_blank" to={Routes.TermsOfUse} className="underline">
        Terms of Use
      </Link>
      , and{' '}
      <Link target="_blank" to={Routes.PrivacyPolicy} className="underline">
        Privacy Policy
      </Link>
      .
    </div>
  );
};
Policies.displayName = 'PoliciesFooter';
